import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface Feature {
  icon: string;
  title: string;
  description: string;
}

const WhyChooseUs = () => {
  const features: Feature[] = [
  {
    icon: 'VideoCameraIcon',
    title: 'Live Interactive Classes',
    description: 'Join real-time sessions with expert instructors and engage with peers through interactive discussions and Q&A.'
  },
  {
    icon: 'ClockIcon',
    title: 'Flexible Learning Schedule',
    description: 'Access recorded sessions anytime and learn at your own pace while staying connected with the cohort.'
  },
  {
    icon: 'UserGroupIcon',
    title: 'Collaborative Community',
    description: 'Connect with fellow learners, share insights, and build lasting professional relationships.'
  },
  {
    icon: 'AcademicCapIcon',
    title: 'Industry-Recognized Certificates',
    description: 'Earn credentials that showcase your expertise and boost your career advancement opportunities.'
  },
  {
    icon: 'ChartBarIcon',
    title: 'Personalized Progress Tracking',
    description: 'Monitor your learning journey with detailed analytics and receive tailored recommendations.'
  },
  {
    icon: 'ShieldCheckIcon',
    title: 'Expert Instructor Support',
    description: 'Get guidance from industry professionals with years of real-world experience in their fields.'
  }];


  return (
    <section className="bg-transparent py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          



          <h2 className="font-headline text-3xl sm:text-4xl lg:text-5xl font-bold text-white drop-shadow-lg mb-4">
            Your Success is Our Mission
          </h2>
          <p className="text-lg text-white/90 max-w-2xl mx-auto drop-shadow-md">
            We combine expert instruction, flexible learning, and community support to create the perfect environment for professional growth.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) =>
          <div
            key={index}
            className="group bg-white/10 backdrop-blur-md p-6 rounded-xl border border-white/20 hover:border-primary hover:bg-white/15 hover:shadow-brand transition-all duration-300">

              <div className="inline-flex items-center justify-center w-14 h-14 bg-primary/20 rounded-lg mb-4 group-hover:bg-primary transition-colors duration-300">
                <Icon
                name={feature.icon as any}
                size={28}
                variant="solid"
                className="text-primary group-hover:text-white transition-colors duration-300" />

              </div>
              <h3 className="font-headline text-xl font-bold text-white mb-3 drop-shadow-md">
                {feature.title}
              </h3>
              <p className="text-white/80 leading-relaxed drop-shadow-sm">
                {feature.description}
              </p>
            </div>
          )}
        </div>
      </div>
    </section>);

};

export default WhyChooseUs;